// eslint-disable-next-line import/no-extraneous-dependencies
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-extraneous-dependencies
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { useDataApiServices} from "../../Hooks/useDataServicesApi";
import { DepartmentCrud } from "../../components/departments/department";

/**
 * 
 * @const DepartmentsRender displays the complete week for the reservation page
 * @returns {JSX.Element} HTML content
 */

const Departments = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const departments = useDataApiServices();
    
    return (
        <div className="bg-white overflow-x-auto flex flex-col gap-6 bg-white shadow-lg rounded-lg p-8">
            {
                <div className="flex justify-between">
                    <h2 className="text-2xl font-semibold py-2 px-4"> 
                        Liste des services
                    </h2>
                    <Link to="/add-department">
                        <button
                            disabled={departments === undefined}
                            className={`${departments === undefined ? "animate-pulse bg-gray-300 p-5 rounded mt-2 disabled:cursor-not-allowed" : "rounded mt-2 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4"}`}
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        >
                            {departments === undefined ? <>   </> : (
                                <>
                                    <FontAwesomeIcon icon={faPlus} className="mr-2" /> Ajouter un Service
                                </>
                            )}
                        </button>
                    </Link>
                </div>
            }
            <table className="w-full table-auto">
                <thead>
                    <tr className="text-left">
                        <th className="p-4">Titre</th>
                        <th className="p-4">Image</th>
                        <th className="p-4">Espaces associé(s)</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody className="w-full">
                    {departments === undefined ? (
                        <tr>
                            <td colSpan={7} className="text-center p-4">Chargement...</td>
                        </tr>
                    ) : (
                        departments.map((department) => (
                            <DepartmentCrud
                                key={department.id}
                                {...department}
                            />
                        ))
                    )}
                </tbody>
            </table>
        </div>

    );

}
export { Departments };